import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22360 16833"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M10972 0c3820 57 6899 1143 9545 3385 526 445 1026 930 1491 1439 496 545 453 1356-38 1922-460 531-1286 662-1887 276-203-131-383-307-552-484-881-924-1881-1693-3015-2276-2100-1080-4324-1467-6668-1163-1575 204-3035 730-4387 1558-803 492-1535 1075-2190 1754-253 261-507 524-781 764-608 535-1495 504-2048-58-555-562-601-1429-58-2028C2688 2544 5464 807 8892 232 9697 97 10517 49 10972 0z"
        className="fil0"
      />
      <path
        d="M4038 9851c0-323 153-687 441-987 831-868 1675-1722 2742-2315 1633-908 3372-1269 5230-1048 2302 274 4141 1394 5661 3094 626 700 608 1664-27 2284-638 622-1584 614-2289-11-509-452-982-966-1551-1327-2142-1357-4755-1031-6580 764-325 319-632 659-981 949-525 434-1124 485-1737 192-588-281-929-861-909-1595z"
        className="fil0"
      />
      <path
        d="M13837 14224c-2 1426-1189 2614-2608 2608-1429-5-2601-1183-2600-2614 2-1430 1180-2609 2605-2607s2605 1186 2603 2613z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
